export const ERROR_PAGE_THEME_COLOR = '#004482';
